import { LOCAL } from "@/store/mutations";

const { ALLOCATE_BUDGET, RESET_BUDGET } = LOCAL;

export default {
	namespaced: true,
	state: () => ({
		id: null,
		type: "",
		title: "",
		allocated: 0,
		lastPercentAllocated: 0,
		locked: false,
	}),
	getters: {
		percentage: (state, getters, rootState) => (state.allocated
			/ rootState.game.balance.amount),
	},
	actions: {
		allocate({ commit }, allocation) {
			commit(ALLOCATE_BUDGET, allocation);
		},
		reset({ commit, getters }) {
			const percent = getters.percentage;
			commit(RESET_BUDGET, { percent });
		},
	},
	mutations: {
		[ALLOCATE_BUDGET](state, allocation) {
			state.allocated = allocation.amount;
		},
		[RESET_BUDGET](state, allocation) {
			state.lastPercentAllocated = allocation.percent;
			state.allocated = 0;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/budgets/single.store.js